import React from 'react';
import useCheckoutState from '../../hooks/useCheckoutState';
import { PaymentElement as StripePaymentElement } from '@stripe/react-stripe-js';
import getBillingDetailsFromFields from '../../lib/getBillingDetailsFromFields';
import getFormFieldValues from '../../lib/getFormFieldValues';
import { findFieldByType } from '../../lib/findFieldByType';

const PaymentElement = ({ setPaymentElementComplete }) => {
  const { setFormError, seller, selectedPaymentMethod, setSelectedPaymentMethod, page } =
    useCheckoutState();
  const { form } = useCheckoutState();

  const { fields } = getFormFieldValues(form.fields, page.fields);
  const billingDetails = getBillingDetailsFromFields(fields);

  const hasRequiredNameField = !!findFieldByType(fields, 'name')?.required;
  const hasRequiredFirstNameField = !!findFieldByType(fields, 'first-name')?.required;
  const hasRequiredLastNameField = !!findFieldByType(fields, 'last-name')?.required;

  const shouldHideNameField =
    hasRequiredNameField ||
    hasRequiredFirstNameField ||
    hasRequiredLastNameField ||
    billingDetails.name;

  return (
    <div className="cp_stripe-payment-element">
      <StripePaymentElement
        onChange={event => {
          if (event.value !== selectedPaymentMethod) {
            setFormError(null);
          }

          setSelectedPaymentMethod(event.value.type);

          if (event.complete) {
            setPaymentElementComplete(true);
          } else {
            setPaymentElementComplete(false);
          }
        }}
        options={{
          defaultValues: {
            billingDetails,
          },
          fields: {
            billingDetails: {
              email: 'never',
              ...(shouldHideNameField && { name: 'never' }),
              ...(billingDetails.phone && { phone: 'never' }),
              ...(billingDetails.address && {
                address: {
                  ...(billingDetails.address.line1 && { line1: 'never' }),
                  ...(billingDetails.address.line2 && { line2: 'never' }),
                  ...(billingDetails.address.city && { city: 'never' }),
                  ...(billingDetails.address.state && { state: 'never' }),
                  ...(billingDetails.address.postal_code && {
                    postal_code: 'never',
                  }),
                  ...(billingDetails.address.country && { country: 'never' }),
                },
              }),
            },
          },

          business: {
            name: seller.displayName || '',
          },
        }}
      />
    </div>
  );
};

export default PaymentElement;
